import axios, { AxiosError, HttpStatusCode } from "axios";
import { API_URL } from "common/config";
import { handleUnauthorized } from "utils/ory";
import LocalStorageService from "./LocalStorageService";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

api.interceptors.request.use(config => {
  const accessToken = LocalStorageService.getAccessToken();
  config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

api.interceptors.response.use(
  config => config,
  async (error: AxiosError) => {
    if (error.response?.status !== HttpStatusCode.Unauthorized) {
      throw error;
    }

    void handleUnauthorized();

    return Promise.reject(error);
  }
);

export default api;
